import RestaurantModalReview from './RestaurantModalReview';

export default RestaurantModalReview;
